<template>
  <header id="page-topbar">
    <div class="navbar-header bg-dark">
      <div class="d-flex align-items-center">
        <!-- LOGO -->
        <div class="navbar-brand-box">
          <router-link tag="a" to="/management" class="logo logo-dark">
            <span class="logo-sm">
              <img :src="whiteLabel || require('@/assets/images/logo-small-white.png')" alt height="22" />
            </span>
            <span class="logo-lg">
              <img :src="whiteLabel || require('@/assets/images/logo-white.png')" alt height="17" />
            </span>
          </router-link>

          <router-link tag="a" to="/management" class="logo logo-light">
            <span class="logo-sm">
              <img :src="whiteLabel || require('@/assets/images/logo-small-white.png')" alt height="22" />
            </span>
            <span class="logo-lg">
              <img :src="whiteLabel || require('@/assets/images/logo-white.png')" alt height="40" />
            </span>
          </router-link>
        </div>

        <button id="vertical-menu-btn" type="button" class="btn btn-sm px-3 font-size-16 header-item" @click="toggleMenu">
          <i class="fa fa-fw fa-bars"></i>
        </button>
      </div>
      <div>
        <h4 class="text-white">
          <i class="bx bx-key font-size-24 align-middle"></i>
          {{ $t("common.management") }}
        </h4>
      </div>

      <div class="d-flex justify-content-end align-items-center">
        <b-dropdown v-if="ondemandLanguage" variant="white" right toggle-class="header-item">
          <template v-slot:button-content>
            <img class :src="ondemandLanguage.flag" height="16" />
            {{ ondemandLanguage.title | translate }}
          </template>
          <b-dropdown-item
            class="notify-item"
            v-for="(entry, i) in languages"
            :key="`Lang${i}`"
            :value="entry"
            @click="setLanguage(entry)"
            :class="{ active: ondemandLanguage.language === entry.language }"
          >
            <img :src="`${entry.flag}`" alt="user-image" class="mr-1" height="12" />
            <span class="align-middle">{{ entry.title | translate }}</span>
          </b-dropdown-item>
        </b-dropdown>

        <b-dropdown right variant="black" toggle-class="header-item">
          <template v-slot:button-content>
            <div class="avatar-xs float-left">
              <span
                v-if="!user.avatar"
                class="
                  avatar-title
                  rounded-circle
                  bg-soft-success
                  text-success
                  font-size-16
                "
              >
                {{ userLetterAvatar }}
              </span>
              <img
                v-else
                :src="user.avatar"
                style="border:1px solid #dbdbdb"
                class="
                  avatar-title
                  rounded-circle
                  bg-white
                "
              />
            </div>

            <span class="d-none d-xl-inline-block ml-1 mt-2">
              {{ user.name }}
            </span>
            <i class="mdi mdi-chevron-down d-none d-xl-inline-block"></i>
          </template>

          <a href="/" class="dropdown-item">
            <i class="bx bxs-dashboard font-size-16 align-middle mr-1"></i>
            {{ $t("dashboard.text") }}
          </a>
          <b-dropdown-divider></b-dropdown-divider>
          <!-- item-->
          <a href="/account" class="dropdown-item">
            <i class="mdi mdi-account font-size-16 align-middle mr-1"></i>
            {{ $t("common.account-profile") }}
          </a>

          <a v-if="isAdminOrOwnerOfAnyWorkpace" href="/workspace" class="dropdown-item">
            <i class="mdi mdi-hexagon-multiple-outline font-size-16 align-middle mr-1"></i>
            {{ $t("workspace.my") }}
          </a>

          <b-dropdown-item @click="goToPage('/forgot-password')">
            <i class="bx bx-lock font-size-16 align-middle mr-1"></i>
            {{ this.$t("account.change-password") }}
          </b-dropdown-item>

          <b-dropdown-divider></b-dropdown-divider>
          <b-dropdown-item @click="logOut()">
            <span class="text-danger">
              <i class="bx bx-power-off font-size-16 align-middle mr-1 text-danger"></i>
              {{ $t("pages.logout") }}
            </span>
          </b-dropdown-item>
        </b-dropdown>
      </div>
    </div>
  </header>
</template>
<script>
import simplebar from "simplebar-vue";

/**
 * Nav-bar Component
 */
export default {
  data() {
    return {
      ondemandLanguage: undefined,
    };
  },
  components: { simplebar },

  computed: {
    userLetterAvatar() {
      const arr = this.user?.name?.split(" ");
      const avatar = [];
      for (const [i, value] of arr.entries()) {
        avatar.push(value.charAt(0));
        if (i == 1) {
          break;
        }
      }
      return avatar.join("");
    },
    user() {
      return this.$store.getters["user/account"];
    },
    languages() {
      return this.$store.getters["localization/languages"];
    },
  },
  mounted() {
    this.ondemandLanguage = this.languages.find((l) => l.language == this.user.language);
  },
  methods: {
    toggleMenu() {
      this.$parent.toggleMenu();
    },
    goToPage(page) {
      this.$router.push(page);
    },
    go(path) {
      window.location.href = path;
    },

    async logOut() {
      await this.$store.dispatch("user/logOut");
    },

    async setLanguage(lang) {
      this.ondemandLanguage = lang;
      await this.$store.commit("user/setLanguage", lang.language);
    },
  },
};
</script>
